export const THERAPY_PLANNING_TESTID_PREFIX = 'therapy-planning';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const therapyPlanningTestId = (
  ...parts: Array<string | number | null | undefined>
): string => [THERAPY_PLANNING_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

export const therapyPlanningRowTestId = (
  base: string,
  identity: string | number | null | undefined,
  suffix?: string
): string | undefined =>
  testIdSlug(identity) ? therapyPlanningTestId(base, identity, suffix) : undefined;

export const patientRowTestId = (patientUuid: string | null | undefined) =>
  therapyPlanningRowTestId('patient', patientUuid);

// Discipline is the value the card is rendered for (PT / OT / SLP), never its label.
export const disciplineCardTestId = (discipline: string | null | undefined, suffix?: string) =>
  therapyPlanningRowTestId('card', discipline, suffix);

export const dayTestId = (isoDate: string | null | undefined, suffix?: string) =>
  therapyPlanningRowTestId('day', isoDate, suffix);

// One grid cell is the intersection of a discipline card, a day column and a mode row. The date is
// the ISO value (2026-09-18), never the rendered "9/18"; the mode is the value (individual /
// concurrent / group), never the label "Individual". Discipline is part of the key because the
// PT, OT and SLP cards all render the same dates and modes.
export const planningCellTestId = (
  discipline: string | null | undefined,
  isoDate: string | null | undefined,
  mode: string | null | undefined,
  suffix?: string
): string | undefined =>
  testIdSlug(discipline) && testIdSlug(isoDate) && testIdSlug(mode)
    ? therapyPlanningTestId('cell', discipline, isoDate, mode, suffix)
    : undefined;

// For the shared common-modals, which take their ids from the caller.
export const confirmCancelTestIds = (dialog: string) => ({
  confirm: therapyPlanningTestId(dialog, 'confirm'),
  cancel: therapyPlanningTestId(dialog, 'cancel'),
});
